import { shallowRef } from 'vue';

import { modalService } from '@exchange/libs/modals/src';
import ErrorModal from '@exchange/libs/modals/src/lib/common/ErrorModal.vue';
import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';
import handleNativeGoTo from '@exchange/libs/utils/capacitor/src/lib/handle-native-go-to';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

const handleAccountHolderIncomplete = () => {
  modalService.show(
    shallowRef(ErrorModal),
    {
      canClose: false,
      closeButtonKey: 'modules.errors.loginFailedAccountHolderIncomplete.action',
      messageKey: 'modules.errors.loginFailedAccountHolderIncomplete.message',
      titleKey: 'modules.errors.loginFailedAccountHolderIncomplete.title',
    },
    {
      'x-error-close': () => {
        const onboardingUrl = `${process.env.VUE_APP_ACCOUNTS_URL}${CONSTANTS.ONBOARDING_PATHNAME}`;

        if (capIsNativePlatform()) {
          handleNativeGoTo(onboardingUrl);
        } else {
          window.location.href = onboardingUrl;
        }

        modalService.clear();
      },
    },
    { canClose: false, centered: true },
  );
};

export default handleAccountHolderIncomplete;
